<div #card *ngIf="product" class="card flex h-full flex-col">
  <div
    class="clickable"
    [routerLink]="['/papeleria/catalogo', product.slug]"
    routerDirection="forward"
    (mouseenter)="setElementHover(true)"
    (mouseleave)="setElementHover(false)"
  >
    <app-product-card-info
      [product]="product"
      [productObservable$]="productSelected$"
      [qty]="this._qty.value"
      [hover]="elementHover"
      [smallLabels]="smallLabels"
      [openCartSteps]="openCartSteps(this.context)"
      [addedToCartConfirmation]="addedToCartConfirmation"
      class="h-full w-full"
    ></app-product-card-info>
  </div>

  <!-- bottom -->
  <div *ngIf="!openCartSteps(this.context)" class="price-row flex flex-row flex-wrap items-end justify-between">
    <app-product-price [product]="product" [highestDiscount]="product.highestDiscount"></app-product-price>
    <ion-button
      #tooltip="tooltip"
      id="add-to-cart"
      class="addToCartButton flex flex-row items-center"
      (click)="updateOpenedProduct(this.context)"
      [tooltip]="'Añadir al carrito'"
      [tooltipClass]="'pink-tooltip'"
      [placement]="'bottom'"
      [showDelay]="10"
      [hideDelay]="20"
    >
      <ion-icon name="add-outline"></ion-icon>
      <ion-icon src="../../../../assets/icon/cart-icon.svg"></ion-icon>
    </ion-button>
  </div>

  <div
    *ngIf="productSelected$ | async; let product"
    class="w-full"
    [ngClass]="{ 'cart-steps': openCartSteps(this.context) }"
  >
    <app-add-to-cart-steps
      *ngIf="openCartSteps(this.context)"
      class="w-full"
      [product]="product"
      [lateralList]="lateralList"
      [inputVariantSelected]="_variantSelected.value"
      (closeEvent)="close()"
      (action)="onAction($event)"
    >
    </app-add-to-cart-steps>
  </div>
</div>
